import { clsx } from 'clsx';
import { Message } from 'game/components/Message';
import { createKeyframes, createStyles } from 'game/lib/createStyles';
import { DialogMessage } from '../MainWorld/dialog/DialogMessage';
import { ConstructionHatBackSprite, ConstructionHatFrontSprite, TearDropSprite } from '../end/EndSprites';
import { FranklinSprite } from './TentIntSprite';

const wave = createKeyframes('wave', {
  '0%': { transform: 'rotate(5deg)' },
  '100%': { transform: 'rotate(-5deg)' },
});

const classes = createStyles({
  wave: {
    transformOrigin: 'center bottom',
    animation: `1.2s ease-in-out infinite alternate ${wave}`,
  },
  construction: {
    marginTop: -10,
  },
});

const defaultPortrait = (
  <svg className={classes.wave} viewBox="0 0 92 85" width={368} height={342}>
    {FranklinSprite}
  </svg>
);

const ConstructionPortrait = ({ hasTear = false }: { hasTear?: boolean }) => (
  <svg className={clsx(classes.construction, { [classes.wave]: !hasTear })} viewBox="0 0 100 111" width={400} height={444}>
    <g transform="translate(12 0)">
      {ConstructionHatBackSprite}
    </g>
    <g transform="translate(0 26)">
      {FranklinSprite}
    </g>
    <g transform="translate(12 0)">
      {ConstructionHatFrontSprite}
    </g>
    {hasTear && (
      <g transform="translate(74 16)">
        {TearDropSprite}
      </g>
    )}
  </svg>
);

export const FranklinDialog: DialogMessage[] = [
  {
    text: <Message text="THE ROBOTS HAVE GONE HAYWIRE!" />,
    portrait: defaultPortrait,
  },
  {
    text: <Message
      text="It's a total mystery! Maybe there are some answers in that {secretLab} nearby."
      values={{
        secretLab: <em><Message text="SECRET LAB" /></em>,
      }}
    />,
    portrait: defaultPortrait,
  },
  {
    text: <Message
      text="Head {south} to the {road} and follow it {east}."
      values={{
        south: <em><Message text="SOUTH" /></em>,
        road: <em><Message text="ROAD" /></em>,
        east: <em><Message text="EAST" /></em>,
      }}
    />,
    portrait: defaultPortrait,
  },
  {
    text: <Message text="Careful out there!" />,
    portrait: defaultPortrait,
  },
];

export const FranklinEndDialog = [
  {
    text: <Message text="Congratulations on making it here!" />,
    portrait: <ConstructionPortrait />,
  },
  {
    text: <Message text="Looks like the rest of the game is still under construction though." />,
    portrait: <ConstructionPortrait hasTear />,
  },
  {
    text: <Message text="Hope you enjoyed it so far. Thanks for playing!" />,
    portrait: <ConstructionPortrait />,
  },
];
